import { connect } from 'react-redux';
import CashPoints from './CashPoints';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.loanTerm,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    sgipToggle: state.sgip.sgipToggle,
    includeESS: state.ess.includeESS,
    essPrice: state.ess.essPrice,
    resiToggle: state.tax.resiToggle,
    taxRate: state.tax.taxRate,
    projectName: state.projectaddress.projectName,
    loanProvider: state.loan.loanProvider,
    mosaicFee: state.loan.mosaicFee,
    showLoan: state.loan.showLoan,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(CashPoints);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CashPoints/index.js